export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-emotion-line' },
];

export const movies = [
  {
    id: 1,
    title: '长安三万里',
    slug: 'chang-an-san-wan-li',
    category: 'movie',
    rating: 9.2,
    year: 2023,
    region: '中国大陆',
    type: '动画 / 历史',
    poster: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20animated%20film%20movie%20poster%20style%2C%20poet%20Li%20Bai%20riding%20horse%20under%20moonlight%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20cinematic%20composition%2C%20soft%20atmospheric%20lighting%2C%20dramatic%20sky%20with%20clouds%2C%20elegant%20artistic%20style&width=600&height=800&seq=movie-poster-01&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animated%20film%20scene%20with%20ancient%20palace%20and%20cherry%20blossoms%2C%20warm%20golden%20sunset%20lighting%2C%20traditional%20Chinese%20architecture%2C%20dreamy%20atmospheric%20composition%2C%20soft%20focus%20background%2C%20rich%20warm%20color%20tones%2C%20cinematic%20widescreen%20aesthetic&width=600&height=800&seq=movie-bg-01&orientation=portrait',
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。',
    duration: '168分钟',
    tags: ['热播', '高分'],
    updateDate: '2026-08-10',
  },
  {
    id: 2,
    title: '流浪地球3',
    slug: 'liu-lang-di-qiu-3',
    category: 'movie',
    rating: 8.8,
    year: 2025,
    region: '中国大陆',
    type: '科幻 / 冒险',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20movie%20poster%2C%20giant%20planet%20in%20sky%20with%20futuristic%20spaceships%2C%20icy%20landscape%20on%20earth%20surface%2C%20dramatic%20blue%20and%20orange%20color%20contrast%2C%20epic%20cinematic%20composition%2C%20warm%20glowing%20engine%20thrusters&width=600&height=800&seq=movie-poster-02&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20scene%20with%20massive%20planetary%20engines%20on%20frozen%20earth%2C%20orange%20glow%20against%20dark%20sky%2C%20futuristic%20vehicles%20crossing%20icy%20terrain%2C%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20grand%20scale&width=600&height=800&seq=movie-bg-02&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出。',
    duration: '173分钟',
    tags: ['热门', '推荐'],
    updateDate: '2026-08-09',
  },
  {
    id: 3,
    title: '繁花',
    slug: 'fan-hua',
    category: 'tv',
    rating: 9.4,
    year: 2024,
    region: '中国大陆',
    type: '剧情 / 爱情',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%201990s%20Shanghai%20nostalgic%20style%2C%20elegant%20woman%20in%20cheongsam%20dress%20under%20neon%20lights%2C%20warm%20golden%20and%20burgundy%20colors%2C%20retro%20cinematic%20aesthetic%2C%20vintage%20glamour&width=600&height=800&seq=movie-poster-03&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Shanghai%20Bund%20at%20night%20in%201990s%2C%20neon%20signs%20reflecting%20on%20Huangpu%20River%2C%20vintage%20cars%20on%20streets%2C%20warm%20golden%20streetlights%2C%20nostalgic%20atmosphere%2C%20rich%20amber%20tones&width=600&height=800&seq=movie-bg-03&orientation=portrait',
    description: '九十年代的上海处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，跻身成为商界后起之秀。黄河路上，人人争奇斗艳。',
    duration: '30集',
    tags: ['热播', '高分'],
    updateDate: '2026-08-11',
  },
  {
    id: 4,
    title: '庆余年第二季',
    slug: 'qing-yu-nian-2',
    category: 'tv',
    rating: 9.0,
    year: 2025,
    region: '中国大陆',
    type: '古装 / 权谋',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20handsome%20man%20in%20ancient%20Chinese%20royal%20robe%2C%20holding%20sword%2C%20traditional%20palace%20background%2C%20warm%20golden%20and%20deep%20red%20color%20scheme%2C%20epic%20cinematic%20style&width=600&height=800&seq=movie-poster-04&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20interior%20with%20golden%20dragon%20pillars%2C%20warm%20candlelight%20atmosphere%2C%20traditional%20silk%20curtains%2C%20mysterious%20shadowy%20corners%2C%20rich%20red%20and%20gold%20decor&width=600&height=800&seq=movie-bg-04&orientation=portrait',
    description: '范闲在经历了一系列生死考验后，再次踏上征途。他将面临更加复杂的朝堂局势和更加凶险的江湖纷争。',
    duration: '36集',
    tags: ['热门', '高分'],
    updateDate: '2026-08-08',
  },
  {
    id: 5,
    title: '乘风破浪的姐姐',
    slug: 'cheng-feng-po-lang',
    category: 'variety',
    rating: 8.7,
    year: 2025,
    region: '中国大陆',
    type: '真人秀 / 音乐',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20elegant%20women%20performers%20on%20stage%20with%20spotlights%2C%20glamorous%20outfits%2C%20concert%20atmosphere%2C%20warm%20golden%20stage%20lighting%2C%20energetic%20pose%2C%20vibrant%20colors&width=600&height=800&seq=movie-poster-05&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Grand%20stage%20with%20brilliant%20golden%20spotlights%2C%20concert%20performance%20setting%2C%20dramatic%20lighting%20effects%2C%20warm%20amber%20and%20white%20beams%2C%20professional%20stage%20design%2C%20atmospheric%20fog&width=600&height=800&seq=movie-bg-05&orientation=portrait',
    description: '多位30+女艺人回归舞台，通过封闭式训练和舞台竞演，最终选择多位姐姐成团出道。展现当代女性独立、自信、勇敢的精神风貌。',
    duration: '12期',
    tags: ['热播'],
    updateDate: '2026-08-10',
  },
  {
    id: 6,
    title: '哪吒之魔童闹海',
    slug: 'ne-zha-2',
    category: 'anime',
    rating: 9.5,
    year: 2025,
    region: '中国大陆',
    type: '动画 / 奇幻',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%2C%20mythological%20boy%20warrior%20with%20flaming%20wheels%20and%20red%20silk%20ribbon%2C%20stormy%20sea%20background%2C%20vibrant%20red%20and%20gold%20colors%2C%20epic%20mythological%20style&width=600&height=800&seq=movie-poster-06&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Mythological%20Chinese%20sea%20with%20massive%20waves%20and%20dragons%20emerging%20from%20water%2C%20stormy%20sky%20with%20lightning%2C%20divine%20red%20glow%2C%20epic%20fantasy%20battle%20scene%2C%20dramatic%20composition&width=600&height=800&seq=movie-bg-06&orientation=portrait',
    description: '天劫之后，哪吒、敖丙的灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，过程中却遇到重重困难。',
    duration: '144分钟',
    tags: ['热门', '推荐', '高分'],
    updateDate: '2026-08-11',
  },
  {
    id: 7,
    title: '封神第二部',
    slug: 'feng-shen-2',
    category: 'movie',
    rating: 8.5,
    year: 2025,
    region: '中国大陆',
    type: '奇幻 / 战争',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20film%20poster%2C%20ancient%20warriors%20in%20battle%20armor%20with%20mythical%20beasts%2C%20dramatic%20sky%20with%20dark%20clouds%2C%20golden%20and%20bronze%20color%20palette%2C%20epic%20scale&width=600&height=800&seq=movie-poster-07&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20battlefield%20with%20thousands%20of%20soldiers%2C%20mythical%20creatures%20in%20sky%2C%20dramatic%20sunset%20lighting%2C%20dust%20and%20smoke%2C%20cinematic%20war%20scene%2C%20warm%20bronze%20tones&width=600&height=800&seq=movie-bg-07&orientation=portrait',
    description: '商王殷寿暴虐无道，姬发觉醒带领西岐军民反抗暴政。一场人、仙、妖之间旷日持久的大战拉开帷幕。',
    duration: '148分钟',
    tags: ['推荐'],
    updateDate: '2026-08-07',
  },
  {
    id: 8,
    title: '狂飙',
    slug: 'kuang-biao',
    category: 'tv',
    rating: 9.3,
    year: 2023,
    region: '中国大陆',
    type: '剧情 / 犯罪',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20police%20officer%20in%20dark%20alley%20with%20neon%20reflections%2C%20gritty%20urban%20night%20scene%2C%20warm%20streetlight%20and%20cool%20shadow%20contrast%2C%20noir%20style&width=600&height=800&seq=movie-poster-08&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Dark%20urban%20Chinese%20street%20at%20night%20with%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20mysterious%20atmosphere%2C%20warm%20amber%20streetlights%2C%20investigative%20crime%20drama%20mood%2C%20cinematic%20noir&width=600&height=800&seq=movie-bg-08&orientation=portrait',
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海。',
    duration: '39集',
    tags: ['经典', '高分'],
    updateDate: '2026-08-06',
  },
  {
    id: 9,
    title: '向往的生活',
    slug: 'xiang-wang-de-sheng-huo',
    category: 'variety',
    rating: 8.3,
    year: 2025,
    region: '中国大陆',
    type: '真人秀 / 生活',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20people%20cooking%20in%20rustic%20countryside%20kitchen%2C%20warm%20sunlight%20through%20windows%2C%20green%20bamboo%20forest%20outside%2C%20cozy%20pastoral%20atmosphere%2C%20natural%20warm%20tones&width=600&height=800&seq=movie-poster-09&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20Chinese%20countryside%20courtyard%20with%20traditional%20wooden%20house%2C%20bamboo%20grove%2C%20golden%20afternoon%20sunlight%2C%20vegetable%20garden%2C%20warm%20pastoral%20scene%2C%20natural%20green%20and%20golden%20light&width=600&height=800&seq=movie-bg-09&orientation=portrait',
    description: '节目中主人公们一起守拙归田园，为观众带来一幅"自力更生、自给自足、温情待客、完美生态"的生活画面。',
    duration: '14期',
    tags: ['推荐'],
    updateDate: '2026-08-05',
  },
  {
    id: 10,
    title: '深海',
    slug: 'shen-hai',
    category: 'anime',
    rating: 8.6,
    year: 2023,
    region: '中国大陆',
    type: '动画 / 奇幻',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%2C%20young%20girl%20in%20underwater%20dreamy%20world%20with%20colorful%20jellyfish%2C%20deep%20ocean%20with%20bioluminescent%20creatures%2C%20magical%20warm%20light%20beams%2C%20surreal%20beauty&width=600&height=800&seq=movie-poster-10&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Magical%20deep%20ocean%20scene%20with%20vibrant%20colorful%20coral%20reefs%2C%20glowing%20jellyfish%2C%20shafts%20of%20warm%20sunlight%20piercing%20through%20water%2C%20ethereal%20underwater%20fantasy%20world%2C%20rich%20warm%20and%20cool%20contrast&width=600&height=800&seq=movie-bg-10&orientation=portrait',
    description: '在大海的最深处，藏着所有秘密。一位现代少女参宿误入梦幻的深海世界，却因此邂逅了一段独特的生命旅程。',
    duration: '112分钟',
    tags: ['高分'],
    updateDate: '2026-08-04',
  },
  {
    id: 11,
    title: '飞驰人生2',
    slug: 'fei-chi-ren-sheng-2',
    category: 'movie',
    rating: 8.1,
    year: 2024,
    region: '中国大陆',
    type: '喜剧 / 运动',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20racing%20film%20poster%2C%20racing%20car%20on%20track%20with%20dust%20trail%2C%20driver%20in%20helmet%2C%20desert%20racing%20background%2C%20warm%20sunset%20colors%2C%20dynamic%20action%20shot%2C%20cinematic&width=600&height=800&seq=movie-poster-11&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Racing%20cars%20on%20desert%20rally%20track%20at%20sunset%2C%20dust%20kicking%20up%2C%20dramatic%20golden%20hour%20lighting%2C%20speed%20motion%20blur%2C%20competitive%20racing%20atmosphere%2C%20warm%20orange%20and%20amber%20sky&width=600&height=800&seq=movie-bg-11&orientation=portrait',
    description: '昔日的冠军车手张驰沦为落魄驾校教练，过着靠脸吃饭勉强度日的生活。不料天上掉馅饼，濒临停产的老头乐车厂厂长主动提出赞助张驰组建车队。',
    duration: '129分钟',
    tags: ['热门'],
    updateDate: '2026-08-03',
  },
  {
    id: 12,
    title: '间谍过家家',
    slug: 'jian-die-guo-jia-jia',
    category: 'anime',
    rating: 9.1,
    year: 2024,
    region: '日本',
    type: '动画 / 喜剧',
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20spy%20family%20poster%2C%20stylish%20family%20of%20three%20in%20formal%20attire%20with%20playful%20expression%2C%20pastel%20warm%20color%20palette%2C%20clean%20illustration%20style%2C%20fun%20atmosphere&width=600&height=800&seq=movie-poster-12&orientation=portrait',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20European%20style%20living%20room%20with%20warm%20afternoon%20sunlight%2C%20elegant%20furniture%2C%20family%20photo%20frames%2C%20soft%20beige%20and%20cream%20tones%2C%20peaceful%20domestic%20scene%2C%20warm%20atmosphere&width=600&height=800&seq=movie-bg-12&orientation=portrait',
    description: '为了执行秘密任务，间谍黄昏必须组建一个临时家庭。他收养了能读心的女儿阿尼亚，并与杀手约尔假结婚。这个各怀秘密的家庭开始了热闹非凡的日常生活。',
    duration: '25集',
    tags: ['热门', '高分'],
    updateDate: '2026-08-02',
  },
];

export const articles = [
  {
    id: 1,
    title: '2026年暑期档最值得期待的十部电影盘点',
    slug: '2026-summer-movies',
    category: '影评',
    cover: 'https://readdy.ai/api/search-image?query=Cinema%20movie%20theater%20interior%20with%20red%20curtains%20and%20warm%20golden%20stage%20lighting%2C%20empty%20plush%20seats%2C%20cinematic%20atmosphere%2C%20elegant%20classic%20theater%20design%2C%20warm%20amber%20glow&width=1200&height=600&seq=article-cover-01&orientation=landscape',
    summary: '暑期档向来是电影市场的兵家必争之地。2026年的暑期档更是群雄逐鹿，多部国产大片蓄势待发。本文将为你盘点最值得期待的十部影片。',
    content: `随着气温逐渐升高，2026年暑期档的大幕也即将拉开。今年的暑期档可谓是百花齐放，从动画大片到科幻巨制，从喜剧片到悬疑片，各种类型应有尽有。

【科幻巨制再续辉煌】

《流浪地球3》无疑是今年暑期档最受瞩目的影片之一。作为中国科幻电影的里程碑系列，前两部作品累计票房已突破百亿大关。第三部将继续讲述人类在宇宙中寻找新家园的壮丽旅程。

【国漫崛起势不可挡】

近年来，国产动画电影的质量和票房屡创新高。《哪吒之魔童闹海》作为《哪吒之魔童降世》的续作，承载着无数观众的期待。影片在视觉效果上更进一步，同时延续了前作的精神内核。

【现实主义题材持续发力】

除了商业大片，今年暑期档也不乏优秀的现实主义题材作品。多部聚焦社会热点、反映时代变迁的影片将与观众见面，用镜头语言讲述普通人的不平凡故事。

总的来说，2026年暑期档的影片类型丰富、质量上乘，无论是喜欢视效大片的观众，还是偏爱深度思考的影迷，都能在这个夏天找到适合自己的作品。`,
    author: '影视观察员',
    date: '2026-08-10',
    readCount: 15820,
    tags: ['暑期档', '电影推荐', '国产电影'],
  },
  {
    id: 2,
    title: '《繁花》为何能成为年度现象级电视剧',
    slug: 'fan-hua-phenomenon',
    category: '剧评',
    cover: 'https://readdy.ai/api/search-image?query=Shanghai%20Bund%20at%20night%20with%20glowing%20neon%20signs%20reflecting%20on%20river%2C%20vintage%201990s%20aesthetic%2C%20warm%20golden%20city%20lights%2C%20romantic%20atmosphere%2C%20nostalgic%20Chinese%20urban%20scene&width=1200&height=600&seq=article-cover-02&orientation=landscape',
    summary: '从播出至今，《繁花》的热度持续不减。这部以上海为背景的年代剧，凭借精良的制作、深刻的人物刻画和独特的叙事风格，成为近年来少有的现象级作品。',
    content: `《繁花》自播出以来，不仅收视率一路飘红，更在社交媒体上引发了广泛的讨论热潮。这部由王家卫执导的年代剧，究竟有何魅力能让观众如此着迷？

【极致的视听美学】

王家卫将电影级别的视听语言带入了电视剧领域。每一帧画面都经过精心构图，光影的运用达到了极致。上海的弄堂、黄河路的霓虹、外滩的江景，都被赋予了独特的诗意和美感。

【细腻的人物刻画】

剧中每个角色都有血有肉，无论是主角阿宝的奋斗历程，还是配角们的喜怒哀乐，都让观众感同身受。人物之间的情感纠葛既真实又动人，折射出那个特殊年代的人情冷暖。

【时代的缩影】

《繁花》不仅仅是一部电视剧，更是九十年代上海城市变迁的缩影。改革开放的浪潮、市场经济的发展、个人命运与时代洪流的交织，都在剧中得到了生动呈现。

这部剧的成功，证明了观众对高质量国产剧的渴望，也为整个行业树立了新的标杆。`,
    author: '剧评人小李',
    date: '2026-08-09',
    readCount: 23650,
    tags: ['繁花', '国产剧', '王家卫', '年代剧'],
  },
  {
    id: 3,
    title: '国产动画电影：从"低幼"到"全年龄段"的华丽转身',
    slug: 'chinese-animation-evolution',
    category: '行业观察',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20artists%20working%20on%20digital%20tablets%2C%20colorful%20character%20designs%20on%20walls%2C%20warm%20creative%20workspace%20lighting%2C%20modern%20creative%20office%2C%20artistic%20atmosphere&width=1200&height=600&seq=article-cover-03&orientation=landscape',
    summary: '近年来，国产动画电影市场发生了翻天覆地的变化。从《大圣归来》到《哪吒》，再到《深海》，国产动画电影正在实现从"低幼向"到"全年龄段"的跨越式发展。',
    content: `十年前，提到国产动画电影，大多数人脑海中浮现的还是《喜羊羊》和《熊出没》这样的低幼向作品。而今天，国产动画电影的格局已经发生了根本性的改变。

【技术突破是基础】

从《大圣归来》的精良3D制作，到《深海》创新的"粒子水墨"技术，国产动画在视觉呈现上不断突破自我。制作团队在渲染技术、角色建模、场景设计等方面投入了大量心血，使得国产动画的画面质量已经能够与国际一流作品比肩。

【故事内核的深化】

技术只是手段，真正打动人心的永远是故事本身。新一代的国产动画电影不再满足于简单的善恶二元对立，而是开始探讨更加复杂的主题——命运与选择、个人与集体、传统与现代的碰撞。

【文化自信的表达】

国产动画电影的崛起，也是中国文化自信的体现。从神话传说到历史典故，从民间故事到当代生活，越来越多的中国元素被巧妙地融入动画创作中，形成了独具特色的"中国动画学派"。

我们有理由相信，国产动画电影的黄金时代才刚刚开始。`,
    author: '动漫评论家',
    date: '2026-08-08',
    readCount: 9850,
    tags: ['国产动画', '动漫产业', '文化自信'],
  },
  {
    id: 4,
    title: '综艺节目的创新之路：从娱乐到价值的转变',
    slug: 'variety-show-innovation',
    category: '综艺观察',
    cover: 'https://readdy.ai/api/search-image?query=Television%20production%20studio%20with%20professional%20lighting%20rig%2C%20cameras%20and%20stage%20setup%2C%20warm%20atmospheric%20backlight%2C%20broadcast%20studio%20environment%2C%20creative%20production%20scene&width=1200&height=600&seq=article-cover-04&orientation=landscape',
    summary: '随着观众审美的提升和政策导向的变化，国内综艺节目正在经历一场深刻的转型。从纯娱乐到寓教于乐，从模仿引进到原创输出，综艺节目的内容生态正在重构。',
    content: `回望过去几年的综艺市场，我们不难发现一个明显的趋势：纯粹追求娱乐效果的节目越来越难以获得观众的认可，而那些兼具娱乐性和社会价值的作品则异军突起。

【文化类综艺的春天】

《国家宝藏》《典籍里的中国》等文化类综艺的走红，证明了观众对优质文化内容有着强烈的需求。这些节目将厚重的历史文化以生动有趣的方式呈现，让观众在轻松愉悦中获得知识的滋养。

【真人秀的转型升级】

真人秀节目也在经历转型升级。从早期的"纯娱乐"到现在的"人文关怀"，《向往的生活》《乘风破浪的姐姐》等节目在保持娱乐性的同时，更加注重传递积极向上的价值观。

【原创能力的提升】

过去国内综艺市场充斥着引进和模仿的作品，而近年来原创综艺的数量和质量都有了显著提升。越来越多的制作团队开始从中国本土文化和社会现实中汲取创作灵感。

综艺节目的创新之路，本质上是对"好内容"的重新定义。`,
    author: '综艺频道编辑',
    date: '2026-08-07',
    readCount: 7230,
    tags: ['综艺节目', '原创综艺', '文化综艺'],
  },
  {
    id: 5,
    title: '《庆余年第二季》口碑与热度双丰收的背后',
    slug: 'qing-yu-nian-2-review',
    category: '剧评',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20blooming%20plum%20blossoms%2C%20traditional%20architecture%2C%20morning%20mist%2C%20warm%20golden%20sunlight%2C%20poetic%20historical%20drama%20atmosphere%2C%20elegant%20composition&width=1200&height=600&seq=article-cover-05&orientation=landscape',
    summary: '作为2025年最受期待的古装剧之一，《庆余年第二季》不负众望，在播出后迅速成为话题中心。本文将分析这部剧为何能够延续第一季的辉煌。',
    content: `《庆余年第二季》的播出，再次证明了优质内容对观众的强大吸引力。这部剧不仅延续了第一季的高水准制作，在剧情深度和人物塑造上更是有了质的飞跃。

【权谋升级，格局更大】

第二季的剧情从庆国朝堂延伸到了更广阔的国际舞台。范闲在应对内部权力斗争的同时，还需要面对来自其他国家的挑战。多条故事线交织推进，让整部剧的叙事层次更加丰富。

【角色成长有血有肉】

范闲从一个"穿越者"逐渐成长为真正的"庆国人"，这种身份的转变和内心的挣扎被演员诠释得淋漓尽致。其他角色也都有各自的成长弧线，让观众能够与他们产生深刻的情感共鸣。

【制作水准持续在线】

从服装道具到场景搭建，从动作设计到镜头调度，第二季的制作水准不仅没有下降，反而在多个方面超越了第一季。这种对品质的坚持，是国产剧走向成熟的标志。

好内容永远不会被埋没，这是《庆余年第二季》给整个行业最好的启示。`,
    author: '资深剧评人',
    date: '2026-08-06',
    readCount: 19200,
    tags: ['庆余年', '古装剧', '国产剧', '权谋'],
  },
  {
    id: 6,
    title: '2026年流媒体平台竞争格局分析',
    slug: 'streaming-platform-2026',
    category: '行业观察',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20home%20entertainment%20setup%20with%20large%20TV%20screen%20displaying%20colorful%20streaming%20interface%2C%20cozy%20living%20room%2C%20warm%20ambient%20lighting%2C%20contemporary%20interior%20design%2C%20comfortable%20atmosphere&width=1200&height=600&seq=article-cover-06&orientation=landscape',
    summary: '国内流媒体市场经过多年的激烈竞争，已经形成了相对稳定的格局。但随着新玩家的入局和技术的发展，2026年的市场又出现了新的变数。',
    content: `2026年，中国流媒体市场的竞争格局仍然充满变数。头部平台凭借内容优势和用户基础继续领跑，而新兴平台则在差异化竞争中寻找突破口。

【内容为王仍是铁律】

无论是传统视频平台还是新兴的短视频平台，优质内容始终是吸引和留住用户的核心要素。各大平台在自制内容上的投入持续增加，精品剧集、综艺节目和电影的版权争夺也日趋激烈。

【技术驱动体验升级】

4K/8K超高清、杜比全景声、AI个性化推荐……技术的进步正在不断提升用户的观影体验。2026年，越来越多的平台开始支持更高规格的音视频标准。

【多元化商业模式】

会员订阅、广告收入、内容分发、IP衍生开发……平台的商业模式正在变得更加多元化。单一依赖会员订阅的模式正在被打破。

流媒体市场的竞争远未结束，对用户来说，这意味着更多优质内容的选择和更好的观影体验。`,
    author: '行业分析师',
    date: '2026-08-05',
    readCount: 6540,
    tags: ['流媒体', '行业分析', '视频平台'],
  },
];